<template>
  <div class="hy-index">
    <!--列表-->
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title active" style="margin-bottom:10px;">
          发票管理
        </h5>
        <van-list v-model="loading" :finished="finished" :finished-text="moreText" @load="onLoad">
          <van-cell v-for="(item,index) in tuiList" :key="item.id">
              <div class="textbox">
                <div class="order_nobox">
                  <div class="order_statusbox border">
                    <span class="o_time">发票申请号：</span>
                    <span class="o_status">{{item.invoice_no}}</span>
                  </div>
                  <div class="order_statusbox border">
                    <span class="o_time">发票类型：</span>
                    <span class="o_status">
                      <template v-if="item.invoice_info.invoice_type == 1">
                        纸质普通发票
                      </template>
                      <template v-if="item.invoice_info.invoice_type == 2">
                        纸质专用发票
                      </template>
                      <template v-if="item.invoice_info.invoice_type == 3">
                        电子普通发票
                      </template>
                     </span>
                  </div>
                  <div class="order_statusbox border">
                    <span class="o_time">审核状态：</span>
                    <span class="o_status">
                      <template v-if="item.status == 1">
                        待审核
                      </template>
                      <template v-if="item.status == 2">
                        审核未通过
                      </template>
                      <template v-if="item.status == 3">
                        审核通过
                      </template>
                      <template v-if="item.status == 4">
                        已取消
                      </template>
                    </span>
                  </div>
                  <div class="order_statusbox border">
                    <span class="o_time">发票金额：</span>
                    <span class="o_status">{{item.amount}}</span>
                  </div>
                  <div class="order_statusbox border">
                    <span class="o_time">申请时间：</span>
                    <span class="o_status">{{item.create_time,'Y-M-D h:m:s'|formatDates}}</span>
                  </div>
                  <div class="btnBox">
                    <router-link class="nav-link blue" :to="'/invoiceInfo/'+item.id"><span class="text">查看详情</span></router-link>
                  </div>
                </div>
              </div>
          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <router-link class="iconfont fixed-link" to="/myInvoice">&#xe66a;</router-link>
    </div>
  </div>
</template>
<script>
  import {
    formatDates
  } from "../../assets/js/date"
  export default {
    data() {
      return {
        allChecked: false,
        moreText: '没有更多了',
        searchValue: "",
        tuiList: [],
        loading: false,
        finished: false,
        page: 0,
        pagesize: 10,
      };
    },
    created() {
      var _this = this;
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: ''
      });

    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      /* 初始化数据列表 */
      onLoad(page, pagesize) {
        var _this = this;
        let url = "/ac1/conference/myInvoice";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize,
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            // 加载状态结束
            _this.loading = false;
            if (res.posts.length < _this.pagesize) {
              _this.finished = true;
              if (_this.page == 1 && res.posts.length == 0) {
                _this.moreText = '暂无内容';
              }
            }
            res.posts.forEach(v => {
              _this.tuiList.push(v);
            });
            _this.page = _this.page + 1;
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });
      },
    }
  };
</script>
